import { createFileRoute } from "@tanstack/react-router";
import SpravatoEs from "@/pages/es/SpravatoEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/spravato`;

export const Route = createFileRoute("/es/spravato")({
  head: () => ({
    meta: [
      { title: "Tratamiento SPRAVATO® | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Neuro Wellness TMS Centers of America es un centro de tratamiento SPRAVATO® REMS certificado en Coral Springs, FL. Si los antidepresivos no han funcionado.",
      },
      {
        property: "og:title",
        content: "Tratamiento SPRAVATO® | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Centro de tratamiento SPRAVATO® REMS certificado en Coral Springs, FL para la depresión resistente al tratamiento.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Tratamiento SPRAVATO® | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Centro de tratamiento SPRAVATO® REMS certificado en Coral Springs, FL para la depresión resistente al tratamiento.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/spravato"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SpravatoEs />;
}
